(function(Drupal, $, once){
    Drupal.behaviors.mo40 = {
        attach() {
            $(once('mo40', 'body')).first().each(function(){
                const toggleClass = 'opened';

                $(document).on("click", ".MO40__trigger" , function() {
                    $(this).parent().toggleClass(toggleClass);
                    $(this).attr( 'aria-expanded', $(this).attr('aria-expanded') === 'true' ? false : true);
                });

                // Close popup when clicking outside, if already opened.
                $(document).click(function(e) {
                    var $target = $(e.target);

                    $('.MO40').each(function(){
                        var $this = $(this);
                        var exceptions = '.MO40__trigger, .MO40__popup';
                        if ($this.hasClass(toggleClass) && !$target.closest(exceptions).length) {
                            $this.removeClass(toggleClass);
                            $('.MO40__trigger').attr( 'aria-expanded', 'false' );
                        }
                    });
                });
            });
        }
    };
})(Drupal, jQuery, once);
